"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const search__white_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons-bg/search--white.svg"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function Search({ className, onSearch, size = 'medium', placeholder, ...props }) {
    const inputId = ((s) => {
        switch (s) {
            case 'small':
                return 'search-field-small';
            case 'large':
                return 'search-field-big';
            case 'medium':
            default:
                return 'search-field';
        }
    })(size);
    const sizeClassForm = ((s) => {
        switch (s) {
            case 'small':
                return 'usa-search--small';
            case 'large':
                return 'usa-search--big';
            case 'medium':
            default:
                return undefined;
        }
    })(size);
    const [searchInput, setSearchInput] = (0, react_1.useState)('');
    function onChange(e) {
        e.preventDefault();
        setSearchInput(e.currentTarget.value);
    }
    function search(e) {
        // Prevent the form from reloading the page
        e.preventDefault();
        onSearch(searchInput);
    }
    return ((0, jsx_runtime_1.jsxs)("form", { className: (0, uswds_react_utils_1.createClassString)('usa-search', sizeClassForm, className), onSubmit: search, role: "search", ...props, children: [(0, jsx_runtime_1.jsx)("label", { className: "usa-sr-only", htmlFor: inputId, children: "Search" }), (0, jsx_runtime_1.jsx)("input", { className: "usa-input", id: inputId, name: "search", onChange: onChange, type: "search", placeholder: placeholder }), (0, jsx_runtime_1.jsx)("button", { className: "usa-button", type: "submit", children: size === 'small' ? ((0, jsx_runtime_1.jsx)("img", { src: search__white_svg_1.default, className: "usa-search__submit-icon", alt: "Search" })) : ((0, jsx_runtime_1.jsx)("span", { className: "usa-search__submit-text", children: "Search" })) })] }));
}
exports.default = Search;
